export const iconFontAwesomeSecurityPeopleRobbery = (
	<i className="fa-solid fa-people-robbery"></i>
);
